var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', _vm._b({
    staticClass: "mui-toggle-btn",
    class: [
      _vm.size ? ("mui-toggle-btn--" + _vm.size) : '',
      _vm.color ? ("mui-toggle-btn--" + _vm.color) : '',
      {
        'mui-toggle-btn--selected': _vm.selected,
        'mui-toggle-btn--disabled': _vm.disabled,
        'mui-toggle-btn--full-width': _vm.fullWidth
      }
    ],
    attrs: {
      "disabled": _vm.disabled,
      "aria-pressed": _vm.selected.toString(),
      "aria-label": _vm.ariaLabel
    },
    on: {
      "click": _vm.handleClick
    }
  }, 'button', _vm.$attrs, false), [(_vm.$slots.icon || _vm.icon) ? _c('span', {
    staticClass: "mui-toggle-btn__icon"
  }, [_vm._t("icon", [_vm._v(_vm._s(_vm.icon))])], 2) : _vm._e(), _vm._v(" "), (_vm.label || _vm.$slots.default) ? _c('span', {
    staticClass: "mui-toggle-btn__label"
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.label))]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#1e8823e8"
    }
  }, [_vm._v(_vm._s(_vm.extra))])], 2) : _vm._e(), _vm._v(" "), (_vm.$slots['icon-right']) ? _c('span', {
    staticClass: "mui-toggle-btn__icon mui-toggle-btn__icon--right"
  }, [_vm._t("icon-right")], 2) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24590c71","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Button/ToggleButton.vue
// module id = 507
// module chunks = 0